import { IOccupier } from '@/bundles/Occupiers/types';
import { Nullable } from '@/utils/types';
import { IPeriod } from '@/bundles/RentSchedule/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

export * from './getOccupierArtivityKeysMapping';
export * from './merge/index';

export const getOccupierLeaseTermLengthByPeriods = (periods: IPeriod[]): Nullable<string> => {
  if (!periods?.length) {
    return null;
  }

  const calculatedTerm = {
    days: 0,
    months: 0
  };

  periods.reduce((acc, item) => {
    acc[item.period_type] += item.periods;

    return acc;
  }, calculatedTerm);

  return `${calculatedTerm.months ? `${calculatedTerm.months} Months` : ''} ${calculatedTerm.days ? `${calculatedTerm.days} Days` : ''}`;
}

export const getOccupierLeaseTermLength = (occupier: IOccupier): Nullable<string> => {
  if (!occupier?.schedule?.periods?.length) {
    return null;
  }

  return getOccupierLeaseTermLengthByPeriods(occupier.schedule.periods);
};

// Free rent is always in months — lease.term is how the rent is quoted, not a unit. The schedule's free
// periods (no rent per SF) keep its days apart; without a schedule only the stored months number is known.
export const getOccupierFreeRentLength = (occupier: IOccupier): Nullable<string> => {
  const freePeriods = (occupier?.schedule?.periods || []).filter((period: IPeriod) => Number(period.total_per_sf) === 0);
  const freeRent = occupier?.ofRecord ? occupier.ofRecord.free_rent : occupier?.free_rent;

  if (freePeriods.length) {
    return getOccupierLeaseTermLengthByPeriods(freePeriods)?.trim() || null;
  }

  return isValuePresent(freeRent) ? `${freeRent} Months` : null;
};
